import React from "react";
import LoginForm from "@/components/auth/login";

const Login: React.FC = () => {
    return <LoginForm />;
};

export default Login;
